import {Grid} from "@mui/material";
import styled from "@mui/system/styled";
import {Search} from "@mui/icons-material";

export const TextInputFlex = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const TextInputFullWidth = styled(Grid)(() => ({
  flex: 1
}));

export const TextInputSearchIcon = styled(Search)(() => ({
  color: 'rgba(0, 0, 0, 0.54)'
}));
